import { collabStateManager } from '@databases/collab-state-manager';
import { useDatabaseContent } from '@databases/database-state';
// FIXME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import { appStoreUtils } from '@databases/redux/store';
import { AsyncOperationStatus } from '@databases/redux-types';
import { selectDatabaseByContentIdStatus } from '@databases/utils/redux/databases/selectors';
// FIXME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import useView from '@databases/views/useView';
import { useEffect } from 'react';

import {
  getFieldsCount,
  getFieldTypeCounts,
  getFieldTypes,
  getEntriesCount,
  getViewsCount,
} from './database-size/resolvers';
import { type DatabaseSizeMetrics } from './main';
import { useAnalytics } from './useAnalytics';
import { getDatabaseContainerType } from './utils';

let databaseSizeMetrics: DatabaseSizeMetrics = {
  contentId: false,
  entriesCount: false,
  fieldsCount: false,
  fieldTypeCounts: false,
  fieldTypes: false,
  viewsCount: false,
};

export function getDatabaseSizeMetrics(): DatabaseSizeMetrics {
  return databaseSizeMetrics;
}

function setDatabaseSizeMetrics(metrics: DatabaseSizeMetrics): void {
  databaseSizeMetrics = {
    contentId: metrics.contentId,
    entriesCount: metrics.entriesCount,
    fieldsCount: metrics.fieldsCount,
    fieldTypeCounts: metrics.fieldTypeCounts,
    fieldTypes: metrics.fieldTypes,
    viewsCount: metrics.viewsCount,
  };
}

export const useTrackDatabaseMetrics = () => {
  const { contentId } = useDatabaseContent();
  const { view } = useView();
  const analytics = useAnalytics();

  const manager = collabStateManager.getCollabManager(contentId);

  const databaseStatus = appStoreUtils.useSelector((state) =>
    selectDatabaseByContentIdStatus(state, { contentId })
  );

  function getViewSettings() {
    return {
      layoutType: view.settings.layout.type,
      showNumberedEntriesEnabled: view.settings.layout.showNumberedEntries,
      cardWidth: view.settings.layout.cardWidth,
    };
  }

  useEffect(() => {
    if (
      !contentId ||
      databaseStatus?.status !== AsyncOperationStatus.SUCCEEDED ||
      !manager
    ) {
      return;
    }

    const fire = () => {
      const jsonData = manager.database.toJSON();
      const attributes = {
        fieldsCount: getFieldsCount(jsonData),
        fieldTypeCounts: getFieldTypeCounts(jsonData),
        fieldTypes: getFieldTypes(jsonData),
        entriesCount: getEntriesCount(jsonData),
        viewsCount: getViewsCount(jsonData),
        viewSettings: getViewSettings(),
      };

      setDatabaseSizeMetrics({ ...attributes, contentId });

      analytics.sendDatabaseProfiledEvent({
        contentId,
        databaseContainer: getDatabaseContainerType(),
        attributes,
      });
    };

    fire();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [databaseStatus?.status, contentId, manager]);
};
